<template>

  <div class="animated fadeIn">
    <b-col sm="12" lg="12">
      <b-card ref="cardRef" class="backClass">

        <!-- Title and Filter -->
        <h4 style="display:inline-block">Backlog by Location</h4>
        <b-form-input
          style="display:inline-block; width:250px;float:right"
          v-model="searchQuery"
          type="search"
          id="filterInput"
          placeholder="Type to Search"
        ></b-form-input>
        <hr />
        <!-- Title and Filter END -->

        <!-- Loading -->
        <div style="height: 400px; padding-top: 150px" class="loading" v-if="loadingData">
          <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                    <div class="sk-child sk-double-bounce1"></div>
                    <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
          </b-row>
        </div>
        <!-- Loading END -->

        <!-- Locations List -->
        <b-row>
          <template  v-for="location in filterItems(locations)">
              <b-col lg="3" sm="6" :key="location.id" style="padding: 5px;">
              <a
                  class="locationLabels"
                  :href="'#/base/city/?loc=' + location.id + '&city=' + location.locaton + '&lat=' + location.lat + '&lng=' + location.lng"
              >{{location.locaton}}</a> <span v-if="location.backlog != 0" style="color:yellow">{{location.backlog}}</span>
              </b-col>
          </template>
        </b-row>
        <!-- Locations List END -->

      </b-card>
    </b-col>
  </div>

</template>


<script>
export default {
  components: {},
  props: ["locationData"],
  data() {
    return {
      searchQuery: "",
      loadingData: false,
      locations: []
    };
  },
  methods: {
    fetchLocations() {
        this.loadingData = true;
        this.$http.get("api/commscope/profile/alphaLocationsBacklog.php", {
        })
        .then(
          res => {
            console.log(res.data)
            this.locations = res.data.records;
            this.loadingData = false;
            console.log(this.loadingData)
          },
          err => {
            console.log(err);
            this.loadingData = false;
          }
        );
    },
    filterItems: function(locations) {
      var app = this;
      return locations.filter(function(location) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return location.locaton.match(regex);
      });
    }
  },
  mounted() {
    this.fetchLocations();
  }
};
</script>

<style scoped>
.locationLabels {
  padding: 9px;
}
</style>
